<template>
  <base-draggable-card-view
    v-model:maximized="maximized"
    card-type="bottom"
    x-init-pos="270px"
    maximized-init-width="450px"
    :init-always-minimized="true"
  >
    <template #toolbarContent="scope">
      <div>Problems</div>
      <v-spacer />

      <v-badge
        v-if="issues > 0"
        :color="severityColor"
        text-color="surface"
        :content="issues"
        offset-y="25"
        offset-x="5"
        style="margin-inline-end: 10px"
      >
        <v-btn-icon size="small" icon="mdi-alert" @click="scope.minMax()"> </v-btn-icon>
      </v-badge>
      <v-btn-icon v-else size="small" icon="mdi-alert" @click="scope.minMax()"> </v-btn-icon>
    </template>
    <template #content="scope">
      <problem-list v-show="scope.show" :diagnostics="diagnostics" class="problem-view-list" :height="listHeight"
    /></template>
  </base-draggable-card-view>
</template>

<script setup lang="ts">
import ProblemList from "./ProblemList.vue";
import { ModelEventBus } from "../../event-bus";
import { DiagnosticsErrorInformation, IErrorInformative } from "../services/ui/view/error-informative";
import { IdentifiableDiagnostic } from "../services/validation-service";
import { ref, onMounted, onBeforeUnmount, computed } from "vue";

import BaseDraggableCardView from "../../shared/BaseDraggableCardView.vue";

const listHeight = ref(0);

const maximized = ref<boolean>(false);

const diagnostics = ref<Array<IdentifiableDiagnostic>>([]);
const diagnosticsInformation = ref<IErrorInformative>(new DiagnosticsErrorInformation(diagnostics.value));

const setDiagnostics = (newDiagnostics: Array<IdentifiableDiagnostic>) => {
  diagnosticsInformation.value.setValue(newDiagnostics);
  diagnostics.value = newDiagnostics;
};

onMounted(() => {
  ModelEventBus.on("modelValidated", setDiagnostics);
});

onBeforeUnmount(() => {
  ModelEventBus.off("modelValidated", setDiagnostics);
});

const issues = computed((): number => {
  return diagnosticsInformation.value.issueCount;
});
const severityColor = computed((): string => {
  return diagnosticsInformation.value.severityColor;
});
</script>
